module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "tablink t-left"
  }, [_c('span', {
    staticClass: "h7 regular c-dark"
  }, [_vm._v(_vm._s(_vm.compTitle))]), _vm._v(" "), _c('span', {
    staticClass: "h7 medium c-dark upcase"
  }, [_vm._v(_vm._s(_vm.compSubtitle))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-95afda82"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/elements/TabLink.vue
// module id = 656
// module chunks = 0